const language = {
    'pt': 
        {
            add_new:            'Adicionar novo',
            align:              'Alinhamento',
            align_horizontal:   'Horizontal',
            align_horizontal_left:      'Esquerda',
            align_horizontal_center:    'Centro',
            align_horizontal_right:     'Direita',
            align_vertical:     'Vertical',
            align_vertical_top:     'Topo',
            align_vertical_middle:  'Meio',
            align_vertical_bottom:  'Fundo',
            archive:            'Arquivo',
            avaiable:           'Disponível até',
            abstract:           'Resumo',
            back:               'Voltar',
            button_visible:     'Botão visível?',
            cancel:             'Cancelar',
            close:              'Fechar',
            content:            'Banners',
            content_add:        'Adicionar bloco',
            choose_link:        'Escolher link',
            choose_link_button: 'Link no botão',
            choose_link_image:  'Link na imagem',
            choose_category:    'Pressione no enter para escolher a categoria',
            content_edit:       'Editar conteúdo',
            content_new:        'Novo conteúdo',
            content_list:       'Lista de banners',
            dates:              'Datas',
            date_creation:      'Criação',
            date_avaiable:      'Disponível até',
            date_publication:   'Publicação',
            date_last_update:   'Última actualização',
            delete:             'Eliminar',
            delete_title:       'Eliminar Registo',
            delete_text:        'Tem a certeza que pretende continuar?',
            delete_confirm:     'Sim',
            delete_cancel:      'Não',
            delete_error:       'Problema ao apagar registo!',
            delete_success:     'Registo apagado com sucesso!',
            description:        'Descrição',
            draft:              'Rascunho',
            doc_choose:         'Escolher PDF',
            edit:               'Editar',
            edit_title:         'Editar Registo',
            edit_text:          'Tem a certeza que pretende continuar?',
            edit_confirm:       'Sim',
            edit_cancel:        'Não',
            edit_error:         'Problema ao actualizar registo!',
            edit_success:       'Registo actualizado com sucesso!',
            file_attach:        'Attach file',
            file_remove_all:    'Remove all',
            file_upload:        'Upload file',
            file_upload_all:    'Upload all',
            filter_placeholder: 'Procurar',
            id:                 'ID',
            layout:             'Tipo',
            multimedia:         'Multimédia',
            name:               'Nome',
            name_placeholder:   'Introduza o nome',
            banners:            'Banners',
            banners_add:        'Adicionar bloco',
            banners_edit:       'Editar banner',
            banners_new:        'Novo banner',
            banners_list:       'Lista de banners',
            image:              'Imagem de destaque',
            images:             'Imagens',
            image_choose:       'Escolher imagem',
            insert_title:       'Novo Registo',
            insert_text:        'Tem a certeza que pretende continuar?',
            insert_confirm:     'Sim',
            insert_cancel:      'Não',
            insert_error:       'Problema ao inserir registo!',
            insert_success:     'Registo inserido com sucesso!',
            link:               'Link',
            link_placeholder:   'Introduza o link', 
            page_config:        'Configuração da Página',
            page_parent:        'Parent',
            pages:              'Páginas',
            pdf_documents:      'Documentos PDF',
            principal:          'Principal',
            published:          'Publicado',
            remove:             'Remover',
            schedule:           'Agendar',
            schedule_to:        'Agendado',
            seo_config:         'Configuração SEO',
            seo_description:    'Descrição SEO',
            seo_description_placeholder: 'Introduza a descrição SEO',
            seo_keywords:       'Keywords SEO',
            seo_keywords_small: '(separar por virgula)',
            seo_keywords_placeholder: 'Introduza as keywords SEO',
            seo_title:          'Título SEO',
            seo_title_placeholder: 'Introduza o título SEO',
            table_rows_per_page:'Registos por página:',
            table_separator:    'de',
            table_all:          'Todos',
            table_title:        'Título',
            table_parent:       'Parent',
            table_date:         'Data',
            table_date_published: 'Data de Publicação',
            table_state:        'Estado',
            table_actions:      'Acções',
            text:               'Texto',
            title:              'Título',
            title_placeholder:  'Introduza o título',
            save:               'Salvar',   
            subtitle:           'Subtítulo',
            subtitle_placeholder:  'Introduza o subtítulo',                  
        },
    'en':
        {
            align:              'Position',
            align_horizontal:   'Horizontal',
            align_horizontal_left:      'Left',
            align_horizontal_center:    'Center',
            align_horizontal_right:     'Right',
            align_vertical:     'Vertical',
            align_vertical_top:     'Top',
            align_vertical_middle:  'Middle',
            align_vertical_bottom:  'Bottom',
            add_new:            'Add new',
            archive:            'Archive',
            avaiable:           'Avaiable until',
            abstract:           'Abstract',
            back:               'Back',
            button_visible:     'Visible button?',
            cancel:             'Cancel',
            close:              'Close',
            content:            'Banners',
            content_add:        'Add block',
            choose_link:        'Choose link',
            choose_link_button: 'Button link',
            choose_link_image:  'Image link',
            choose_category:    'Press enter to add new tag',
            content_edit:       'Edit content',
            content_new:        'New content',
            content_list:       'Banners list',
            dates:              'Dates',
            date_creation:      'Creation',
            date_avaiable:      'Avaiable until',
            date_publication:   'Publication',
            date_last_update:   'Last update',
            delete:             'Delete',
            delete_title:       'Delete Regist',
            delete_text:        'Are you sure you want to continue?',
            delete_confirm:     'Yes',
            delete_cancel:      'No',
            delete_error:       'Problem deleting the element!',
            delete_success:     'Element deleted successfully!',
            description:        'Description',
            draft:              'Draft',
            doc_choose:         'Choose PDF',
            edit:               'Edit',
            edit_title:         'Edit Regist',
            edit_text:          'Are you sure you want to continue?',
            edit_confirm:       'Yes',
            edit_cancel:        'No',
            edit_error:         'Problem updating element!',
            edit_success:       'Successful updated element!',
            file_attach:        'Attach file',
            file_remove_all:    'Remove all',
            file_upload:        'Upload file',
            file_upload_all:    'Upload all',
            filter_placeholder: 'Search',
            id:                 'ID',
            layout:             'Type',
            multimedia:         'Multimedia',
            name:               'Name',
            name_placeholder:   'Insert the name',
            banners:            'banners',
            banners_add:        'Add block',
            banners_edit:       'Edit banner',
            banners_new:        'New banner',
            banners_list:       'Article List',
            image:              'Highlight image',
            images:             'Images',
            image_choose:       'Choose image',
            insert_title:       'New Regist',
            insert_text:        'Are you sure you want to continue?',
            insert_confirm:     'Yes',
            insert_cancel:      'No',
            insert_error:       'Problem updating element!',
            insert_success:     'Successful updated element!',
            page_config:        'Page config',
            page_parent:        'Parent',
            pages:              'Pages',
            pdf_documents:      'PDF Documents',
            principal:          'Principal',
            published:          'Publicado',
            remove:             'Remove',
            schedule:           'Schedule',            
            schedule_to:        'Schedule', 
            seo_config:         'SEO config',
            seo_description:    'SEO description',
            seo_description_placeholder: 'Insert the SEO description',
            seo_keywords:       'SEO keywords',
            seo_keywords_small: '(separate by comma)',
            seo_keywords_placeholder: 'Insert the SEO keywords',
            seo_title:          'SEO title',
            seo_title_placeholder: 'Insert the SEO title',
            table_rows_per_page:'Regist by page:',
            table_separator:    'of',
            table_all:          'All',
            table_title:        'Title',
            table_parent:       'Parent',
            table_date:         'Date',
            table_date_published: 'Published date',
            table_state:        'State',
            table_actions:      'Actions',
            text:               'Text',
            title:              'Title',
            title_placeholder:  'Insert title',
            save:               'Save',
            subtitle:           'Subtitle',
            subtitle_placeholder:  'Insert subtitle',  
        }
}

module.exports = {
    language
};